import '../../shared/error-boundary.ts';
/**
 * Tool page entry — data-url-encode
 */

import { urlEncode } from '@bytario/core/data/url-encode';
import { createProgress, yieldToPaint } from '../../shared/progress.ts';

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[c]!);
}

const button = document.querySelector('#run') as HTMLButtonElement;
button.addEventListener('click', async () => {
  const input = (document.querySelector('#text') as HTMLTextAreaElement).value;
  if (!input) return;
  const p = createProgress('#result', ['Encoding', 'Complete']);
  try {
    p.activate(0);
    await yieldToPaint();
    const encoded = await urlEncode(new TextEncoder().encode(input));
    const output = typeof encoded === 'string' ? encoded : new TextDecoder().decode(encoded);
    const diff = output.length - input.length;
    const diffLabel = diff > 0 ? '+' + diff + ' chars' : diff + ' chars';
    p.complete(0);

    p.activate(1);
    p.complete(1);
    p.finish(
      '<div class="side-by-side">' +
        '<div><h3>Original (' + input.length + ' chars)</h3><pre class="wrap">' + escapeHtml(input) + '</pre></div>' +
        '<div><h3>Encoded (' + output.length + ' chars, ' + diffLabel + ')</h3><pre class="wrap">' + escapeHtml(output) + '</pre></div>' +
      '</div>'
    );
  } catch (e) {
    p.error(String(e));
  }
});
